<svelte:head>
  <!-- <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@100&display=swap"
    rel="stylesheet"
  /> -->
</svelte:head>

<section class="features text-center section-padding" id="features">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 class="arrow"> Experience is rarely shown on paper, but here is a list anyway....  </h1>
        <!-- Love what you do, and you'll do it well -->
        <div class="features-wrapper">
          <!-- -webkit-animation-delay :1s -->

          <div class="clearfix" />
        </div>
      </div>
    </div>
  </div>


<div style="margin-bottom:40px">
  <div class="qualifications">
    <div class="span4">
      <ul>
        <span class="color-text ">
          <h4>Instructing Qualifications</h4>
          <li>Royal Yachting Association Powerboat Instructor</li>
          <li>Royal Yachting Association Dinghy Instructor</li>
          <li>British Canoe UKCC L2 Canoe/Kayak</li>
          <br />

          <h4>Leader Certificates & Training</h4>
          <li>Mountain Leader*</li>
          <li>Canoe Leader OpenWater*</li>
          <li>Canoe Leader Whitewater*</li>
          <li>Kayak Leader Whitewater*</li>
          <br />

          <h4>Operational Qualifications</h4>
          <li>Whitewater Safety and Rescue</li>
          <li>2 Day Outdoor First Aid</li>
          <li>RYA SRC (Short Range Certificate) / Marine Radio (VHF)</li>
          <br />
        </span>
      </ul>
    </div>

    <div class="span4">
      <ul>
        <span class="color-text ">
          <h4>Legacy Courses</h4>
          <li>
            2 Day first Aid
            <ul class="minor">
              <li>MediRec '20</li>
              <li>Previous</li>
            </ul>
          </li>
          <li>
            RYA First Aid inc CAT-C
            <ul class="minor">
              <li>RYA '19</li>
            </ul>
          </li>
          <li>
            1 Day First Aid
            <!-- <ul class="minor"
            >
            <li>Deaf and Disabled '22</li>
            <li>Digital Age 19'</li>
            <li>SCUK '14</li>
            <li>SCUK '09</li>
        </ul> -->
          </li>
          <li>
            Safeguarding and Protecting Childern
            <ul class="minor">
              <li>Deaf and Disabled '22</li>
              <li>Digital Age 19'</li>
              <li>SCUK '14</li>
              <li>SCUK '09</li>
            </ul>
          </li>
          <li>BCU Lifeguards Canoe Safety</li>
          <li>BC Foundation Saftey and Rescue</li>
        </span>
      </ul>
    </div>

    <div class="span4">
      <ul>
        <span class="color-text ">
          <h4>Teaching</h4>
          <li>Safeguarding and Protecting Children</li>
          <li>Teaching people with Disabilities (York University)</li>
          <li>Exploring sport coaching and psychology (Open University)</li>
          <li>Fundamentals of Paddling and Performance Coaching</li>
          <li>DBS Checked</li>

          <br />
          <h4>Memberships</h4>
          <li>*British Canoe</li>
          <li>*Association of Mountain Instructors</li>
          <li>British Mountaineering</li>
          <li>Royal Yachting Association</li>
        </span>
      </ul>
    </div>

    <br />
  </div>
</div>
</section>
<style>
  h4 {
    padding-top: 0.5em;
    
    text-decoration: underline overline;
    text-underline-offset: 4px;
    color: #c0c9cf;
  }

 .span4 li {
    /* font-family: 'Inconsolata', monospace; */

    font-family: 'IBM Plex Sans', sans-serif;
    /* font-weight: 200 !important; */
    font: inherit;
    left: 1em;

    width: clamp(200px, 30vw, 33vw);
    /* margin-right: auto; */
  }

  .qualifications {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    /* padding-top: 3em; */
    position: relative;
    clear: both;
    height: auto;
    flex-basis: 30%;
    /* padding-bottom: 300px; */
  }

  .qualifications.child {
    flex-basis: 30%;
  }

  li {
    padding-top:.4em;
    color: #85afcb;
    display: list-item;
    list-style-type: circle; /* Remove bullets */
  }

  .minor {
    padding-left: 1em;
    font-size: small;
    /* fs:smaller */
    padding-bottom: .2em;
  }

  .minor > li {
    list-style-type: ' - ';
  }
</style>
